import axios from "axios";
import {
  GET_ALL_ADMISSION_PROGRAMS,
  GET_ALL_APPLYTHROUGH,
  GET_ALL_BOARD,
  GET_ALL_MARKSTYPE,
  GET_ACPC_DETAILS_BY_STUDENTID,
  GET_ALL_MEDIUM,
} from "./types";
const keys = require("../config/keys");

export const getAllAdmissionProgramByFormId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetAllAdmissionProgramByFormId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_ADMISSION_PROGRAMS,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllApplyThroughList = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionForm/GetAllApplyThroughList"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_APPLYTHROUGH,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllBoardList = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionForm/getAllBoardList"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_BOARD,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllMediumList = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionForm/getAllMediumList"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_MEDIUM,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getAllMarksTypeList = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionForm/getAllMarksTypeList"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_MARKSTYPE,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const getACPCdetailsByStudentId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetACPCdetailsByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ACPC_DETAILS_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getAllAdmissionProgram.js